// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class CascadeRulesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicCascadeRules';
        this.Server = this.props.context.getState().server.publicCascadeRules;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name'];
        this.showDatePicker = false;

        const defaultHead = [
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'kind',
                label: 'kind',
                alignRight: false,
                cell: 'Items',
                items: ['ecom', 'p2p', 'payout', 'redirect' ],
                displayGrid: true,
            },
            {
                id: 'cascadeRule',
                label: 'cascadeRule',
                alignRight: false,
                cell: 'Rules',
                displayGrid: true,
            }

        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
